import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { DialogPatientComponent } from 'src/app/shared/components/dialog-patient/dialog-patient.component';
import { Patient } from '../models/patient.model';

@Injectable({
  providedIn: 'root'
})
export class PatientDialogService {

  constructor(
    private dialog: MatDialog
  ) { }

  openPatientDialog(patient?: Patient): Observable<any> {
    history.pushState('openedScreen', 'openedScreen');
    return this.dialog.open(DialogPatientComponent, {
      closeOnNavigation: true,
      restoreFocus: false,
      width: '360px',
      data: patient,
      panelClass: ['full-screen-sm']
    }).afterClosed().pipe(
      tap(() => {
        if (history.state === 'openedScreen') {
          history.back();
        }
      })
    );
  }
}
